var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAllEntity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 -11 1046 1046",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.708871h448.101143v448.101143H0z",
    fill: "#2B96DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M605.860608 0h439.65791v439.65791H605.860608z",
    fill: "#DC712B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.442386 575.88713h448.101143v448.101143H1.442386zM607.291267 573.17826h439.65791V1012.83617H607.291267z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllEntity);
export default __webpack_public_path__ + "static/media/all-entity.7af39b74c58bcbb28cfcd1d5eda632b6.svg";
export { ForwardRef as ReactComponent };